/**
 * useSpiceBandDefault gives the band a SPICE visit starts on in the note
 * composer: the client's own session kind, read from
 * GET /clients/{id}/spice-plan (defaultSpiceBandForSessionKinds), so a
 * client whose every session is a Friendly Visitor one starts on Friendly
 * Visitor. Until that read answers, and when it cannot (no plan, a
 * refusal), the start is SPICE. The person may always pick the other
 * band with the composer's rate-band pills.
 */

import { useClientSpicePlan } from '@/lib/spiceVisitPlansApi';
import {
  defaultSpiceBandForSessionKinds,
  SPICE_BAND,
  type SpiceVisitRateBand,
} from '@/lib/spiceVisitNote';

/** `clientId` null, or `enabled` false, reads nothing and answers SPICE. */
export function useSpiceBandDefault(
  tenantSlug: string,
  clientId: string | null,
  opts: { enabled?: boolean } = {},
): SpiceVisitRateBand {
  const enabled = (opts.enabled ?? true) && clientId !== null;
  const { data } = useClientSpicePlan(tenantSlug, clientId ?? '', { enabled });
  if (!enabled) return SPICE_BAND;
  return defaultSpiceBandForSessionKinds((data?.plan?.sessions ?? []).map((s) => s.kind));
}
